import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {BIPageSearchModel} from "../bi-page-search.model";
import {BIPageEntityModel} from "../bi-page-entity.model";

@Component({
    selector: "wbo-bi-page-search-page",
    templateUrl: "./bi-page-search-page.component.html",
    providers: [provideSearchModel(BIPageSearchModel), provideEntityModel(BIPageEntityModel)]
})
export class BIPageSearchPageComponent extends AbstractSearchPage {
    constructor(public model: BIPageSearchModel) {
        super();
    }
}
